import React, { useEffect, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Button,
    CardActions,
    CardContent,
    Divider,
    Grid,
    IconButton,
    InputBase,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';
import { gridSpacing } from 'store/constant';
import ApiLink from 'API';
import axios from 'axios';
import { useNavigate } from 'react-router';
import RefreshIcon from '@mui/icons-material/Refresh';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import moment from 'moment';
import { exportToCSV } from 'ui-component/exportToCSV';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
const StockCard = ({ cusId }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const [SumCount, setSumCount] = useState(0);
    const [Data, setData] = useState([]);
    const [Value, setValue] = useState('');
    const [Datasearch, setDatasearch] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [DateFilterInventory, setDateFilterInventory] = useState(new Date());

    // dateValue: a Date to view inventory "as of", or '^' for the current live stock
    const LoadData = async (dateValue) => {
        try {
            setisLoading(true);
            const param = dateValue && dateValue !== '^' ? encodeURIComponent(new Date(dateValue).toISOString()) : '^';
            const response = await axios.get(ApiLink + '/api/stockcustomer/customer/inventory/filter/' + param, {
                withCredentials: true,
                headers: { token: localStorage.getItem('token') }
            });
            if (response.status === 200) {
                const responseData = response.data.data || [];
                setData(responseData);
                setDatasearch(responseData);
                const SumValue = responseData.map((item) => item.qty || 0).reduce((prev, next) => prev + next, 0);
                setSumCount(SumValue);
                setisLoading(false);
            } else if (response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            setisLoading(false);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
    };

    useEffect(() => {
        LoadData('^');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cusId]);
    useEffect(() => {
        if (Value !== '') {
            const data = Data.filter(
                (item) =>
                    item.productName.toLowerCase().includes(Value.toLowerCase()) ||
                    item.productId.includes(Value.toLowerCase()) ||
                    item.model.toLowerCase().includes(Value.toLowerCase())
            );
            setDatasearch(data);
        } else {
            setDatasearch(Data);
        }
    }, [Value]);
    return (
        <>
            {isLoading ? (
                <SkeletonPopularCard />
            ) : (
                <MainCard content={false} sx={{ maxHeight: '75vh' }}>
                    <CardContent>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Grid container alignContent="center" justifyContent="space-between">
                                    <Grid item>
                                        <Stack direction="row-reverse" alignItems="center">
                                            <MoreHorizOutlinedIcon
                                                fontSize="small"
                                                sx={{ color: theme.palette.primary[200], cursor: 'pointer' }}
                                                aria-controls="menu-vip-inventory"
                                                aria-haspopup="true"
                                                onClick={(e) => setAnchorEl(e.currentTarget)}
                                            />
                                            <Menu
                                                id="menu-vip-inventory"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={() => setAnchorEl(null)}
                                                variant="selectedMenu"
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            >
                                                <MenuItem
                                                    onClick={() => {
                                                        setAnchorEl(null);
                                                        const filename =
                                                            'InventoryVIP-' +
                                                            localStorage.getItem('branchCode') +
                                                            '-' +
                                                            moment(DateFilterInventory).format('YYYY-MM-DD-HH,mm,ss');
                                                        const dataExcel = Datasearch.map((item) => ({
                                                            Model: item.model,
                                                            ProductName: item.productName,
                                                            Memory: item.memory,
                                                            Storage: item.storage,
                                                            Color: item.color,
                                                            Dimension: item.dimension,
                                                            BranchCode: item.branchCode,
                                                            Qty: item.qty,
                                                            total: item.salePrice
                                                        }));
                                                        exportToCSV(dataExcel, filename);
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <ArticleIcon fontSize="small" color="success" />
                                                    </ListItemIcon>
                                                    <ListItemText>Export Excel</ListItemText>
                                                </MenuItem>
                                                <MenuItem>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <MobileDateTimePicker
                                                            label="Inventory Date"
                                                            inputFormat="DD-MM-YYYY HH:mm:ss"
                                                            value={DateFilterInventory}
                                                            onChange={(value) => setDateFilterInventory(value)}
                                                            onAccept={() => {
                                                                setAnchorEl(null);
                                                                LoadData(DateFilterInventory);
                                                            }}
                                                            renderInput={(params) => <TextField size="small" {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() => {
                                                        setAnchorEl(null);
                                                        setDateFilterInventory(new Date());
                                                        LoadData('^');
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <RefreshIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText>Current (live)</ListItemText>
                                                </MenuItem>
                                            </Menu>
                                            <Typography variant="h4">Inventory{'(' + SumCount + ')'}</Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid item>
                                        <Box>
                                            <Paper sx={{ display: 'flex', width: 200 }} elevation={2}>
                                                <InputBase
                                                    type="text"
                                                    fullWidth
                                                    style={{
                                                        marginLeft: 1,
                                                        flex: 1,
                                                        fontFamily: 'boonhome-400'
                                                    }}
                                                    value={Value}
                                                    onChange={(event) => {
                                                        setValue(event.target.value);
                                                    }}
                                                    // onKeyDown={(e) => {
                                                    //     if (e.key === 'Enter') {
                                                    //     }
                                                    //     // if (e.keyCode == 13) {
                                                    //     //     setpage(1);
                                                    //     //     // LoadData(Value);
                                                    //     // }
                                                    // }}
                                                    placeholder="ID, Name, Model.."
                                                    inputProps={{ 'aria-label': 'ID, Name, Model..' }}
                                                    startAdornment={
                                                        <IconButton
                                                            className="iconbutton"
                                                            aria-label="refresh"
                                                            onClick={() => {
                                                                // setData(dataOriginal);
                                                                setValue('');
                                                            }}
                                                        >
                                                            <RefreshIcon />
                                                        </IconButton>
                                                    }
                                                />
                                            </Paper>
                                        </Box>
                                    </Grid>
                                    {/* <Grid item>
                                        <MoreHorizOutlinedIcon
                                            fontSize="small"
                                            sx={{
                                                color: theme.palette.primary[200],
                                                cursor: 'pointer'
                                            }}
                                            aria-controls="menu-popular-card"
                                            aria-haspopup="true"
                                            onClick={handleClick}
                                        />
                                        <Menu
                                            id="menu-popular-card"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                            variant="selectedMenu"
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right'
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right'
                                            }}
                                        >
                                            <MenuItem onClick={handleClose}> Today</MenuItem>
                                            <MenuItem onClick={handleClose}> This Month</MenuItem>
                                            <MenuItem onClick={handleClose}> This Year </MenuItem>
                                        </Menu>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                            {/* <Grid item xs={12} sx={{ pt: '16px !important' }}></Grid> */}
                            <Grid item xs={12}>
                                <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 205px)', overflowX: 'hidden' }}>
                                    {Datasearch.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <Grid container direction="column" spacing={gridSpacing}>
                                                    <Grid item>
                                                        <Avatar
                                                            variant="rounded"
                                                            src={item?.images[0]?.img}
                                                            sx={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: '5px',
                                                                backgroundColor: 'transparent',
                                                                // backgroundColor: theme.palette.success.light,
                                                                // color: theme.palette.success.dark,
                                                                ml: 2
                                                            }}
                                                        >
                                                            {/* <KeyboardArrowUpOutlinedIcon fontSize="small" color="inherit" /> */}
                                                        </Avatar>
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container alignItems="center" justifyContent="space-between">
                                                            <Grid item>
                                                                <Typography variant="subtitle1" color="inherit">
                                                                    {item.productName + ' (' + item.color + ')'}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item>
                                                                <Typography variant="h3" color="inherit">
                                                                    {item.qty}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="subtitle2" sx={{ color: 'success.dark' }}>
                                                            {item.model}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Divider sx={{ my: 1.5 }} />
                                            </div>
                                        );
                                    })}
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {/* <CardActions sx={{ p: 1.25, pt: 0, justifyContent: 'center' }}>
                        <Button size="small" disableElevation>
                            View All
                            <ChevronRightOutlinedIcon />
                        </Button>
                    </CardActions> */}
                </MainCard>
            )}
        </>
    );
};

export default StockCard;
